// actions/popupdata/index.js
export const updateRecord = (formData) => ({
    type: 'UPDATE_RECORD',
    payload: formData,
  });
  

  export const deleteRecord = (id) => ({
    type: 'DELETE_RECORD',
    payload: id,
  });